/*
站内消息相关api
 */
import request from '../request';
export const messagesApi = {
  /**
   *获取所有消息列表
   */
  getNotifications () {
    return request.get('/gw/w/support/web');
  },
  /**
   *获取未读消息列表
   */
  getUnreadNotifications () {
    return request.get('/gw/w/notifications');
  },
  /**
   *获取未读消息数
   */
  getUnreadNotificationsCount () {
    return request.get('/gw/w/notifications/unread_msg_count');
  },

  /**
   *获取已读消息列表
   */
  getReadedNotifications () {
    return request.get('/gw/w/notifications/read_msgs');
  },
  /**
   *获取消息详情
   */
  getNotificationDetail (msgId) {
    return request.get(`/gw/w/notifications/${msgId}`);
  },
  getNotificationDelete (msgId) {
    return request.delete(`/gw/w/notifications/${msgId}`);
  },
};
